import HomeGift from '../assets/images/gift-for-home.webp';
import SelfCare from '../assets/images/gitt-for-self-care.webp';

const GiftsData = [
    {
        title: 'Gifts for home',
        desc: 'Revitalise indoor spaces with gifts designed to illuminate space and instil atmosphere. Each is formulated to set the mood, calm the mind and refresh the mundane.',
        thumbnail: HomeGift
    },
    {
        title: 'Gifts for self-care',
        desc: 'Find special gifts to honour the most complex relationship of all—that which we have with ourselves. Give generously and without restraint.',
        thumbnail: SelfCare
    }
]

export default GiftsData;